var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4545 3H5.63636C4.73636 3 4 3.73636 4 4.63636V16.0909H5.63636V4.63636H15.4545V3ZM17.9091 6.27273H8.90909C8.00909 6.27273 7.27273 7.00909 7.27273 7.90909V19.3636C7.27273 20.2636 8.00909 21 8.90909 21H17.9091C18.8091 21 19.5455 20.2636 19.5455 19.3636V7.90909C19.5455 7.00909 18.8091 6.27273 17.9091 6.27273ZM8.90909 19.3636H17.9091V7.90909H8.90909V19.3636Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.873e9676017993ba8922935f19c683a7.svg";
export { ForwardRef as ReactComponent };